import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { useStateValue } from '@State'
import ExceptionDeleteModal from './ExceptionDeleteModal'
import AllExceptionDeleteModal from './AllExceptionDeleteModal'

export const Exceptions = props => {
  const [currentState, dispatch] = useStateValue()
  const [exceptionDeleteModalOpen, toggleDeleteExceptionModal] = useState(false)
  const [allExceptionDeleteModalOpen, toggleAllDeleteExceptionModal] =
    useState(false)
  const [ruleClass, setRuleClass] = useState('')
  const [showDueDateDeleteAllButton, setShowDueDateDeleteAllButton] =
    useState(false)
  const [showTimeLimitDeleteAllButton, setShowTimeLimitDeleteAllButton] =
    useState(false)

  const openDeleteAllModal = ruleClassString => {
    toggleAllDeleteExceptionModal(!allExceptionDeleteModalOpen)
    setRuleClass(ruleClassString)
  }

  useEffect(() => {
    if (currentState.aggregatedRules.length === 0) {
      setShowDueDateDeleteAllButton(false)
      setShowTimeLimitDeleteAllButton(false)
    }
    let lateCount = 0
    let timeLimitCount = 0
    currentState.aggregatedRules.map(activity => {
      if (activity.rule_map.LateSubmissionRule) {
        lateCount++
      }
      if (activity.rule_map.OvertimeSubmissionRule) {
        timeLimitCount++
      }
    })
    setShowDueDateDeleteAllButton(lateCount > 0)
    setShowTimeLimitDeleteAllButton(timeLimitCount > 0)
  }, [currentState.aggregatedRules])

  return (
    <div>
      <p style={{ marginBottom: '60px' }}>
        | {currentState.aggregatedRules.length} Assignment
        {currentState.aggregatedRules.length !== 1 && 's'} with Exceptions
      </p>
      <div>
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Assignment</th>
              <th>
                Due Date Exception
                {showDueDateDeleteAllButton && (
                  <span
                    onClick={() => openDeleteAllModal('Due Date Exceptions')}
                    style={{ cursor: 'pointer' }}
                    className="fa-solid fa-times fa-fw float-right mt-1"
                  />
                )}
              </th>
              <th>
                Time Limit Exception
                {showTimeLimitDeleteAllButton && (
                  <span
                    onClick={() => openDeleteAllModal('Time Limit Exceptions')}
                    style={{ cursor: 'pointer' }}
                    className="fa-solid fa-times fa-fw float-right mt-1"
                  />
                )}
              </th>
            </tr>
          </thead>
          <tbody>
            {currentState.aggregatedRules.map((activity, idx) => {
              let mmddyyyy = null
              let displayDueDateTime = null
              if (activity.rule_map.LateSubmissionRule) {
                const dueDateRule = new Date(
                  activity.rule_map.LateSubmissionRule.rule_options.due_date
                )
                displayDueDateTime = dueDateRule.toString().split(' ', 5)[4]
                const month = dueDateRule.getMonth()
                const date = dueDateRule.getDate()
                const year = dueDateRule.getFullYear()
                const pad = function pad(n) {
                  return n < 10 ? '0' + n : n
                }
                mmddyyyy = pad(month + 1) + '/' + pad(date) + '/' + year
                if (
                  activity.rule_map.LateSubmissionRule.rule_options.override
                ) {
                  mmddyyyy = 'Removed Due Date'
                }
              }
              let overtimeSubmissionRule = null
              if (activity.rule_map.OvertimeSubmissionRule) {
                if (
                  activity.rule_map.OvertimeSubmissionRule.rule_options.override
                ) {
                  overtimeSubmissionRule = 'Removed Time Limit'
                } else {
                  overtimeSubmissionRule =
                    activity.rule_map.OvertimeSubmissionRule.rule_options
                      .time_limit + ' Minutes'
                }
              }

              return (
                <tr key={idx}>
                  <td>{activity.title}</td>
                  <td>
                    {mmddyyyy && mmddyyyy + ' ' + displayDueDateTime}
                    {mmddyyyy && (
                      <span
                        onClick={() => {
                          dispatch({
                            type: 'updateRuleIdToDelete',
                            selectedForDelete:
                              activity.rule_map.LateSubmissionRule.rule_id,
                          })
                          toggleDeleteExceptionModal(!exceptionDeleteModalOpen)
                        }}
                        style={{ cursor: 'pointer' }}
                        className="fa-solid fa-times fa-fw float-right mt-1"
                      />
                    )}
                  </td>
                  <td>
                    {overtimeSubmissionRule && overtimeSubmissionRule}
                    {overtimeSubmissionRule && (
                      <span
                        onClick={() => {
                          dispatch({
                            type: 'updateRuleIdToDelete',
                            selectedForDelete:
                              activity.rule_map.OvertimeSubmissionRule.rule_id,
                          })
                          toggleDeleteExceptionModal(!exceptionDeleteModalOpen)
                        }}
                        style={{ cursor: 'pointer' }}
                        className="fa-solid fa-times fa-fw float-right mt-1"
                      />
                    )}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
      <Link
        className="btn btn-myed btn-primary btn-primary-myed pull-right"
        to={`/instructor/ada_exceptions/${props.match.params.coursenum}/${props.match.params.studentid}/new_exception`}
      >
        Create Exception
      </Link>
      <ExceptionDeleteModal
        show={exceptionDeleteModalOpen}
        toggle={toggleDeleteExceptionModal}
        studentId={props.match.params.studentid}
      />
      <AllExceptionDeleteModal
        show={allExceptionDeleteModalOpen}
        toggle={toggleAllDeleteExceptionModal}
        studentId={props.match.params.studentid}
        ruleClass={ruleClass}
      />
    </div>
  )
}

Exceptions.propTypes = {
  match: PropTypes.object.isRequired,
}
